import React from 'react';
import MessageError from "../MessageError";

const FormErrorsOutput = ({error, fieldErrors, ...props}) => {
    return (
        <div className={props.className}>
            {error && <MessageError className="text-center" error={error}/> }
            {fieldErrors?.map((error, index) => (
                <div key={index}>
                    <MessageError className="text-center" error={error.message}/>
                </div>
            ))}
        </div>
    );
};

export default FormErrorsOutput;
